import "./GenericSurveyListComponent.scss";

import { ScheduleDTO, SurveyDTO } from "@teams/types/api";
import React from "react";

import { useUserInfo } from "../actions/useUserInfo";
import { isSubscriptionExpired } from "../utils/userHelpers";
import { GenericSurveyCard } from "./GenericSurveyCard";

type GenericSurveyListProps = {
  genericSurveys: (SurveyDTO | ScheduleDTO)[];
  loadInstanceCallback?: () => void;
  loadSeriesCallback?: () => void;
};

export const GenericSurveyList: React.FC<GenericSurveyListProps> = ({
  genericSurveys,
  loadInstanceCallback,
  loadSeriesCallback,
}) => {
  genericSurveys.sort((a, b) => b.updatedAt.getTime() - a.updatedAt.getTime());
  const { user } = useUserInfo();
  const isTrialExpired =
    !!user &&
    isSubscriptionExpired(
      user,
      user.subscriptions.map(sub => sub.plan)
    );

  return (
    <div className="generic-survey-list">
      {genericSurveys.map((survey, index) => {
        return (
          <GenericSurveyCard
            key={index}
            entry={survey}
            loadSeriesCallback={loadSeriesCallback}
            loadInstanceCallback={loadInstanceCallback}
            allowShowResults={!isTrialExpired}
          />
        );
      })}
    </div>
  );
};
